<template>
  <div class="cb-page">
  	<router-view></router-view>
  </div>
</template>
<style src="@/assets/styles/fullPageApp.styl" lang="stylus"></style>
<style src="@/assets/styles/base/_fonts.styl" lang="stylus" scoped></style>
<script type="text/javascript">
import {
    mapGetters
} from "vuex"
export default {
  created() {
    this.$store.dispatch('init_app');
  },
  computed: {
    ...mapGetters(
      [
          'authenticated',
          'inited'
      ]
    )
  }
}
</script>
